import React from 'react'
import { i18nTranslate, currencyFormat, convertToBoolean } from 'src/utils'
import { APPConfig } from 'config/appConfig'
import { Button } from 'react-bootstrap'
import { FiEdit3 as EditIcon } from 'react-icons/fi'
import PriceSubscription from 'src/views/components/Price/PriceSubscription'
import { LinkWithLocale } from 'src/views/components'
import PVCV from '../PVCV'
import EditBundleMultiVariants from '../EditBundleMultiVariants'
import { enableSubscriptionMultiVariant } from 'src/deps'
/**
 * Renders product details for a subscription product.
 * Displays product image, name, SKU, price, frequency,
 * and subtotal. Uses several reusable components.
 */
class ProductDetails extends React.Component {
  render() {
    const {
      data = {},
      productData,
      index,
      isFromDelete,
      isFromModel = false,
    } = this.props
    const {
      frequencyLabel = '',
      quantity = '',
      subTotal,
      isOneTime = false,
      isBundle = false,
      multiVariantEditSource = '',
      bundleItems = {},
      variantInfo = {},
      pathUrl = '',
    } = productData

    let {
      frequencyPeriod = 1,
      frequencyType = 'Every month',
      type = 'VARIABLE_MULTI_ORDER',
      selectedMonth,
      recurrenceOrderProcessingDate,
      properties = {},
    } = data

    const itemId = this.props?.data?.itemInfo?.[0]?.id || ''

    const { bundle = [] } = bundleItems
    const bundleStockStatus = bundle?.[0]?.inventory || ''
    const bundleProductStatus = bundle?.[0]?.status || ''
    const isSkipped = properties?.isSkipped === 'true' || false
    const isToDisableVariantDisplay =
      bundleStockStatus?.toLowerCase() !== 'in stock' ||
      bundleProductStatus?.toLowerCase() !== 'active' ||
      isSkipped

    const isToDisplayVariants =
      enableSubscriptionMultiVariant() &&
      !isFromModel &&
      !isFromDelete &&
      (isBundle || variantInfo.isNormalSkuWithMultiVariant) &&
      (multiVariantEditSource === 'nextOrder' ||
        multiVariantEditSource === 'schedule')

    const frequencyData = {
      frequencyPeriod: frequencyPeriod,
      frequencyType: frequencyType,
      type: type,
    }
    const isDisablePVCVSVPrice = convertToBoolean(
      APPConfig?.getAppConfig()?.disablePVCVSVPrice
    )
    return (
      <div className="product-details-wrapper d-flex">
        <div className="product-info">
          <LinkWithLocale
            to={{
              pathname: pathUrl || '',
            }}
            className={'product-card-product-link'}>
            <div
              className="subs-product-title"
              data-testid="qa-sub-product-name">
              {productData.productName}
            </div>
            <div
              className="subs-product-sku"
              data-testid="qa-sub-product-skuId">
              <span className="">{i18nTranslate('cart.itemId', 'SKU')}:</span>
              <span className="pl-1">{productData?.skuId}</span>
            </div>
          </LinkWithLocale>

          {quantity && isFromDelete && (
            <div
              className="quantity-label pr-1 subs-product-quantity"
              data-testid="qa-sub-product-quantity">
              <span className="pr-1">
                {i18nTranslate('quantity', 'Quantity')}:
              </span>
              {quantity}
            </div>
          )}
          <div className="subscription-price d-flex w-100 subs-product-price">
            <PriceSubscription
              classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
              transactionPrice={{
                ...productData?.priceObj,
                totalValue:
                  productData?.priceObj?.totalValue ||
                  productData?.priceObj?.unitValue,
              }}
              isStarterKit={productData?.isStarterKit}
              partNumber={productData?.partNumber}
            />
          </div>

          {isToDisplayVariants && (
            <EditBundleMultiVariants
              bundleData={productData}
              activeTab={this.props.productData?.multiVariantEditSource}
              itemId={itemId}
              frequencyData={frequencyData}
              month={selectedMonth}
              selectedSubscriptionDate={recurrenceOrderProcessingDate}
              disableSelections={isToDisableVariantDisplay}
              {...this.props}
            />
          )}
          <div className="d-flex frequency-wrapper">
            {!isFromDelete && !isFromModel && (
              <div
                className={`d-flex subs-product-frequency ${
                  isFromModel && `model-frequency`
                }`}>
                {quantity && (
                  <div
                    className="quantity-label pr-1 subs-product-quantity"
                    data-testid="subs-product-quantity">
                    {quantity}
                  </div>
                )}
                {frequencyLabel && (
                  <div
                    className="frequency-label subs-product-frequency"
                    data-testid="frequency">
                    {frequencyLabel}
                  </div>
                )}
              </div>
            )}
            {subTotal && !isFromDelete && (
              <div
                className={`${isFromModel && `model`} sub-total-label d-flex`}
                data-testid="subtotal">
                <span className="subs-product-total-label">
                  {i18nTranslate('subscriptionModal.subTotal', 'Subtotal')}:
                </span>
                <span
                  className="subs-product-total-value pl-1"
                  data-testid="qa-product-subtotal-value">
                  {currencyFormat({
                    // currency: currencyCode,
                    price: subTotal,
                  })}
                </span>
              </div>
            )}
          </div>
          {!isDisablePVCVSVPrice && (
            <PVCV
              data-testid="qa-subscription-sv"
              priceFacets={
                subTotal && !isFromDelete
                  ? productData?.priceObj?.totalValue?.priceFacets
                  : productData?.priceObj?.unitValue?.priceFacets
              }
              oneTime={isOneTime}
            />
          )}
        </div>
      </div>
    )
  }
}

export default ProductDetails
export { ProductDetails }
